import * as React from "react";
const SvgMinus = (props) => /* @__PURE__ */ React.createElement("svg", { width: "800px", height: "800px", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6 12L18 12", stroke: "#000000", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgMinus;
